import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import content from '../static/content.json';
import Question from './FeedbackQuestion';
import questionData from '../static/feedbackQuestions.json';
import "./FormPage.css"; 

const FeedbackPage = () => {
  const [consent, setConsent] = useState(null); // Store consent status here
  const staticText = content.FeedbackPage;

  const [formData, setFormData] = useState({});
  const navigate = useNavigate();
  const caseId = localStorage.getItem('caseId');

  const isDemoMode = localStorage.getItem("caseId") === "demo";
  
  useEffect(() => {
    if (isDemoMode) {
      // Retrieve consent from local storage in demo mode
      const savedData = JSON.parse(localStorage.getItem("issueInfoDemo"));
      if (savedData) {
        setConsent(savedData.consent);
        setFormData(savedData); // Set formData with saved data
      }
    } else {
      const fetchConsent = async () => {
        try {
          const response = await axios.post(
            `https://app.better-retter.de/api/patient/info`,
            {
              patient_id: caseId,
              software: "better-retter",
            }
          );
          setConsent(response.data.data.consent);
        } catch (error) {
          console.error("Error fetching consent status:", error);
        }
      };
      fetchConsent();
    }
  }, [caseId, isDemoMode]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmitFeedback = async (e) => {
    e.preventDefault();
    try {
      if (isDemoMode) {
        // Save feedback data in local storage in demo mode
        localStorage.setItem("feedbackDataDemo", JSON.stringify(formData));
        alert("Feedback saved in demo mode");
        localStorage.removeItem("caseId");
        navigate("/end");
      } else {
        const response = await axios.post(
          `https://app.better-retter.de/api/submit/${caseId}`,
          {
            ...formData,
            software: "better-retter",
            consent: consent,
          }
        );

        if (response.data.success === true) {
          navigate("/end");
        } else {
          alert("Submit failed");
        }
      }
    } catch (error) {
      console.error("Submit error:", error);
      alert("An error occurred during submitting. Please try again.");
    }
  };

  // if (consent === null) return <p>Lädt...</p>;

  return (
    <form onSubmit={handleSubmitFeedback} className="form-container" style={{boxSizing: 'border-box'}}> 
      <div className="form-content">
        <h2>{staticText.TitleOnTop}</h2>

        {/* Consent Messages */}
        {!consent && (
          <h3 style={{ color: "red" }}>{staticText.MessageForNotConsent}</h3>
        )}

        {consent && (
          <h3 style={{ color: "green" }}>{staticText.MessageForConsent}</h3>
        )}

        {/* Questions */}
        {questionData.Questions.map((question) => (
          <Question
            key={question.QuestionNumber}
            question={question}
            formData={formData}
            handleChange={handleChange}
            consent={consent}
          />
        ))}

        <button type="submit" className="form-button form-button-primary" onClick={handleSubmitFeedback}>
          Absenden
        </button>
      </div>
    </form>
  );
};

export default FeedbackPage;